import { useMutation } from '@apollo/client';
import { READ_MESSAGE } from 'services/graphql/mutations/message';
import { GeneralFunction } from 'types/common';

export const useReadMessageCall = () => {
  // const { totalUnreadMessages } = useSelector(SelectedAppointmentContactSelectors.selectAppointmentContact);
  const [readMessage] = useMutation(READ_MESSAGE);

  const triggerReadMessage = async ({
    chatRoomId,
    callbackOnSuccess,
    totalUnreadMessages = 0,
  }: {
    chatRoomId?: string;
    callbackOnSuccess?: GeneralFunction;
    totalUnreadMessages?: number;
  }) => {
    if (!totalUnreadMessages || !chatRoomId) return;
    try {
      await readMessage({ variables: { chatRoom: chatRoomId } });
      callbackOnSuccess?.();
    } catch (err) {
      // do nothing
    }
  };
  return [triggerReadMessage];
};
